/* eslint-disable */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import authActions from '../../redux/features/auth/actions';
import useAuthorizedEpApps from '../../hooks/useAuthorizedEpApps';
import config from '../../config/config';
import { PERFORMANCE_INSIGHTS_APP_NAME } from '../../constants';
import { usePopupManager } from '../../providers/PopupManager/PopupManager';
import styles from './ProcureToPay.module.css';
import VendorPaymentSchemeComp from '../../components/ProcureToPayComp/VendorPaymentSchemeComp';
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom";
import VendorPaymentSchemeMainPage from '../../components/ProcureToPayComp/VendorPaymentSchemeMainPage';

const VendorPaymentSchemePage = ({
  isAuthenticated,
  authPolicies,
  currentUserId,
}) => {

  const authorizedApps = useAuthorizedEpApps(isAuthenticated, authPolicies);
  const { showLoading } = usePopupManager();
    const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    if (
      authorizedApps.length &&
      !authorizedApps.includes(PERFORMANCE_INSIGHTS_APP_NAME)
    ) {
      showLoading();
      window.location.replace(config.HOME_UI_BASE_URL);
    }
  }, [authorizedApps, currentUserId]);

  return (
    <div className={styles.container}>
      {location.pathname === "/Procure-To-Pay/Vendor-Payment-Scheme" ? (
          <VendorPaymentSchemeMainPage />
        ) : (
          <VendorPaymentSchemeComp />
        )}
    </div>
  )
}

VendorPaymentSchemePage.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
  authPolicies: PropTypes.object.isRequired,
  currentUserId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
};
  
export default connect(({ auth, userProfile }) => ({
  isAuthenticated: auth.isAuthenticated,
  authPolicies: auth.authPolicies,
  currentUserId: userProfile.userId,
  setAuthToken: authActions.setAuthToken,
}))(VendorPaymentSchemePage);
